import { FeatureParams } from '@bimdata/definitions/types';
import api from './api';

async function features(): Promise<Record<string, FeatureParams>> {
  if (!api.getSession()) return {};
  const { data } = await api.get(`/info/features`);
  return data;
}

export { features };